import pluralize from 'helpers/pluralize';
import formatNumber from 'helpers/formatNumber';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';

/**
 * This component shows meta data of a label.
 */
function LabelMetadata({ trackCount, releaseCount, artistCount }) {
  return (
    <Meta>
      {shouldRenderValue(trackCount) && (
        <span>{`${formatNumber(trackCount, 'number', true)} ${pluralize(
          'track',
          trackCount
        )}`}</span>
      )}
      {shouldRenderValue(releaseCount) && (
        <span>{`${formatNumber(releaseCount, 'number', true)} ${pluralize(
          'release',
          releaseCount
        )}`}</span>
      )}
      {shouldRenderValue(artistCount) && (
        <span>{`${formatNumber(artistCount, 'number', true)} ${pluralize(
          'artist',
          artistCount
        )}`}</span>
      )}
    </Meta>
  );
}

LabelMetadata.propTypes = {
  ...metadataProps,
};

export default LabelMetadata;
